var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.994 27.9319C22.3249 27.3459 25.076 26.861 25.1076 26.8543L25.165 26.8421L22.0203 23.1168C20.2908 21.0678 18.8757 19.3834 18.8757 19.3737C18.8757 19.3553 22.1228 10.4495 22.1411 10.4178C22.1472 10.4072 24.3569 14.207 27.4977 19.6286C30.4382 24.7044 32.8624 28.8895 32.885 28.9287L32.9259 29L22.9319 28.9987L12.9378 28.9974L18.994 27.9319ZM7 26.7959C7 26.7906 8.48176 24.2288 10.2928 21.1029L13.5856 15.4195L17.423 12.2122C19.5335 10.4482 21.266 9.00271 21.273 9.00007C21.2799 8.99744 21.2521 9.06703 21.2113 9.15473C21.1704 9.24243 19.2953 13.248 17.0444 18.0561L12.9519 26.798L9.97595 26.8017C8.33918 26.8037 7 26.8011 7 26.7959Z",
    fill: "#0089D6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.f6362fcc913d2cd70443774dadfd2a1b.svg";
export { ForwardRef as ReactComponent };